import React, { Suspense } from "react";
import { useParams } from "react-router-dom";
import ErrorBoundary from "../ErrorBoundary/ErrorBoundary";
import LoadingComponent from "../Dashboard/Common/LoadingComponent";
import { verifyLogin } from "../utilities/authHelper";
import { EMBED_SCREENS } from "./embedRegistry";
import useEmbedContext from "./useEmbedContext";

const Message = ({ children }) => (
  <div className="p-4" style={{ fontFamily: "sans-serif" }}>
    {children}
  </div>
);

// Standalone screen for partner desktops: /embed/<screenKey>?instrument=EURUSD.
// No sidebar or tabs; the session comes from a /embed-login launch URL.
const EmbedPage = () => {
  const { screenKey } = useParams();
  const context = useEmbedContext();
  const screen = EMBED_SCREENS[screenKey];

  if (!screen) {
    return <Message>Unknown screen "{screenKey}".</Message>;
  }

  if (!verifyLogin()) {
    return (
      <Message>Session expired. Please reopen this screen from your desktop.</Message>
    );
  }

  return (
    <div
      className="w-100 bg-custom"
      style={{ height: "100vh", overflow: "auto" }}
    >
      <ErrorBoundary>
        <Suspense fallback={<LoadingComponent />}>
          {screen.render(context)}
        </Suspense>
      </ErrorBoundary>
    </div>
  );
};

export default EmbedPage;
